import React from 'react';
import './analysis.css'

const Comparisons = ({comparisons}) => {
    return (
        <div className='analysis'>
            Comparisons: {comparisons}
        </div>
    );
}

export default Comparisons;
